module.exports = __webpack_public_path__ + "static/banner-grey-8919e4401e603c3db56dd7519074a0f2.svg";